/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S2_Li1Inputs */

const en_guide_what_is_json_s2_li1 = /** @type {(inputs: Guide_What_Is_Json_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>String</strong>: Text enclosed in double quotes: <code>"hello world"</code>`)
};

const ko_guide_what_is_json_s2_li1 = /** @type {(inputs: Guide_What_Is_Json_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>String</strong>: 큰따옴표로 감싼 텍스트: <code>"hello world"</code>`)
};

const ja_guide_what_is_json_s2_li1 = /** @type {(inputs: Guide_What_Is_Json_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>文字列</strong>: ダブルクォートで囲まれたテキスト：<code>"hello world"</code>`)
};

/**
* | output |
* | --- |
* | "<strong>String</strong>: Text enclosed in double quotes: <code>\"hello world\"</code>" |
*
* @param {Guide_What_Is_Json_S2_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s2_li1 = /** @type {((inputs?: Guide_What_Is_Json_S2_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S2_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s2_li1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s2_li1(inputs)
	return ja_guide_what_is_json_s2_li1(inputs)
});